import React, { Component } from 'react';
import { array, func, string } from 'prop-types';
import Dropdown from 'ps-components/Dropdown/Dropdown';
import './JobMatchingHeader.scss';

class JobMatchingSliderHeader extends Component {
  static propTypes = {
    applyToJobs: func,
    hideSlideout: func,
    selectedJobs: array,
    selectedRuleName: string
  };

  render() {
    const { applyToJobs, hideSlideout, selectedJobs, selectedRuleName } = this.props;
    const dropdownItems = [
      'Create or Append Pricing Matches',
      'Overwrite Applicable Pricing Matches',
      <span>
        Overwrite <strong>All</strong> Existing Pricing Matches
      </span>
    ];
    const dropdownClass = selectedJobs.length ? 'dropdown__btn' : 'dropdown__btn btn__disabled';

    return (
      <div className="job-matching__header">
        <div className="matching-header__name">{selectedRuleName}</div>
        <div className="matching-header__actions">
          <Dropdown
            className={dropdownClass}
            disabled={!selectedJobs.length}
            dropdownItems={dropdownItems}
            itemOnClick={applyToJobs}
            text="Apply to Jobs"
          />
          <span className="matching-header__close" onClick={hideSlideout}>
            &times;
          </span>
        </div>
      </div>
    );
  }
}

export default JobMatchingSliderHeader;
